// eslint-disable-next-line no-shadow
export enum UpscaleResolution {
	RESOLUTION_2K = '2K',
	RESOLUTION_4K = '4K',
	RESOLUTION_8K = '8K',
}
